export default __webpack_public_path__ + "static/media/car-join.de7afc72.svg";